import { EndSessionRequest } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import Modal from "@components/Modal";
import { useState } from "react";
import Dropdown from "../../Dropdown/Dropdown";
import FeedbackForm from "../../FeedbackForm/FeedbackForm";
import Icon from "../../Icon";
import styles from "./UserDropdown.module.css";

function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(false);
    setIsFeedbackOpen(true);
  };

  const handleCloseModal = () => {
    setIsFeedbackOpen(false);
  };

  const { accounts, instance } = useMsal();
  const account = accounts[0] || null;

  const handleSignOutPressed = () => {
    const logoutRequest: EndSessionRequest = {
      account: instance.getActiveAccount() ?? account,
      postLogoutRedirectUri: null,
    };
    void instance.logoutRedirect(logoutRequest);
  };

  const content = (
    <div className={styles.content}>
      <div>
        <p>{account?.name}</p>
      </div>
      <div>
        <div className="abb-icon Chat"></div>
        <p onClick={handleOpenModal}>Give feedback</p>
      </div>
      <div>
        <div className="abb-icon Log_out"></div>
        <p onClick={handleSignOutPressed}>Log out</p>
      </div>
    </div>
  );

  return (
    <>
      <Dropdown
        anchor="right"
        dropdown={content}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        <div
          className={
            styles["user-icon-container"] + (isOpen ? ` ${styles.open}` : "")
          }
          onClick={() => setIsOpen((o) => !o)}
        >
          <Icon name="User_in_circle" size="1.75rem"></Icon>
        </div>
      </Dropdown>
      <Modal
        visible={isFeedbackOpen}
        onDismiss={handleCloseModal}
        variant="no-padding"
      >
        <FeedbackForm onCancel={handleCloseModal} />
      </Modal>
    </>
  );
}
export default UserDropdown;
